angular.module('zc.projects')
  .directive('zcUniqueCouponCodeList', zcUniqueCouponCodeList);

zcUniqueCouponCodeList.$inject = ['$translate', 'UniqueCouponCode'];
function zcUniqueCouponCodeList($translate, UniqueCouponCode) {
  return {
    restrict: 'E',
    scope: {
      incentive: '=',
      project: '=',
    },
    templateUrl: '/templates/projects.incentives/unique_coupon_code_list.html',
    link: function(scope) {
      scope.visibleItemCount = scope.countPerLoad = 10;
      scope.uniqueCouponCodes = [];

      scope.csvFileName = [
        scope.project.apikey,
        'incentive' + scope.incentive.id,
        moment().format('YYYYMMDD'),
      ].join('-') + '.csv';

      scope.getCSV = () => {
        const csvData = _.map(scope.uniqueCouponCodes, couponCode => {
          let delivered = 'no';
          let deliveryDate = null;
          if(couponCode.assigned_at) {
            delivered = 'yes';
            deliveryDate = moment(new Date(couponCode.assigned_at)).format('YYYY/MM/DD HH:mm:ss');
          }

          return [
            couponCode.coupon_code,
            delivered,
            deliveryDate,
          ];
        });

        csvData.unshift([
          $translate.instant('projectsIncentives.uniqueCouponCodeList.code'),
          $translate.instant('projectsIncentives.uniqueCouponCodeList.delivered'),
          $translate.instant('projectsIncentives.uniqueCouponCodeList.deliveryDate'),
        ]);

        return csvData;
      };

      UniqueCouponCode.all({
        projectId: scope.incentive.project_id,
        incentiveId: scope.incentive.id
      }).then(function(uniqueCouponCodes) {
        scope.uniqueCouponCodes = _.sortBy(uniqueCouponCodes, 'assigned_at');
      });
    }
  };
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.incentives/unique_coupon_code_list.directive.js